(() => {
  if (customElements.get('shop-by-activity')) return;

  class ShopByActivity extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.cards = Array.from(this.querySelectorAll('[data-activity-card]'));
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.cards.forEach((card) => {
        const trigger = card.querySelector('[data-activity-trigger]');
        trigger?.addEventListener('click', this.onTriggerClick);
      });

      const preset = this.cards.find((card) => card.hasAttribute('data-open-by-default')) || this.cards[0];
      if (preset) this.activate(preset.dataset.activityCard);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.cards?.forEach((card) => {
        const trigger = card.querySelector('[data-activity-trigger]');
        trigger?.removeEventListener('click', this.onTriggerClick);
      });
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onTriggerClick(event) {
      const card = event.currentTarget.closest('[data-activity-card]');
      const id = card?.dataset.activityCard;
      if (id) this.activate(id);
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const card = event.target.closest('[data-activity-card]') || event.target;
      const id = card.dataset?.activityCard;
      if (id) this.activate(id);
    }

    activate(id) {
      this.cards.forEach((card) => {
        const on = card.dataset.activityCard === id;
        card.classList.toggle('is-active', on);
        card.toggleAttribute('data-active', on);
        const trigger = card.querySelector('[data-activity-trigger]');
        trigger?.setAttribute('aria-expanded', String(on));

        const item = card.parentElement;
        if (item && item !== this) item.classList.toggle('is-active', on);
      });
    }
  }

  customElements.define('shop-by-activity', ShopByActivity);
})();
